import { GenericHandlerConfig, GenericVideoHandler } from './Generic';

export type VengoHandlerConfig = GenericHandlerConfig & {
    videoUrl: string;
};

/**
 * A handler to play video advertisements from Vengo
 */
export class VengoVideoHandler extends GenericVideoHandler {
    protected _type: string;
    protected _videoId: string;
    constructor(config: VengoHandlerConfig) {
        super(config);
        this._videoId = config.videoUrl;
        this._videoUrl = config.videoUrl;
        this._type = 'vengo';
    }
}
